export default "__VITE_ASSET__C_U5tKXH__"